'use client';

import Link from 'next/link';
import type { ComponentProps } from 'react';

type IntentPrefetchLinkProps = Omit<ComponentProps<typeof Link>, 'prefetch'>;

/**
 * Internal navigation link for chrome (header menus, footer, drawers, blocks).
 *
 * Today this is a plain `<Link>` with the default prefetch. With
 * `partialPrefetching` OFF (next.config.ts), the default prefetch for an
 * in-viewport link is the destination's per-URL static shell — for this
 * storefront's fully prerendered routes that is the entire page, served from
 * the CDN — so a click arrives with its content and no loading state. Never
 * pass `prefetch={true}` here: in this mode it means a dynamic, uncached
 * server render per link.
 *
 * History: under Partial Prefetching (2026-08-23, reverted the same day) this
 * component started on the shared App Shell and upgraded to a runtime prefetch
 * on hover/focus/touch. Measured on the PDP/collection routes, that runtime
 * prefetch was a `private, no-store` ~67 KB live render per link, and links
 * tapped or clicked before it landed stalled with no feedback. The component
 * name is kept so call sites stay stable if an intent policy returns.
 */
export function IntentPrefetchLink(props: IntentPrefetchLinkProps) {
	return <Link {...props} />;
}
